import HeaderProducts from '../../components/general/header/HeaderProducts';

const Products = () => {
  return <div className="row subpage__container">
    <HeaderProducts/>
  </div>
}

export default Products